import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CitadelStylesModule } from '@citadel/styles';
import { CitadelCoreModule, CitadelGlobalErrorHandler } from '@citadel/core';
import { CitadelControlsModule, CitadelOtpInputComponent, CitadelPhoneNumberInputComponent } from '@citadel/controls';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { SignInPageComponent } from './pages/sign-in-page/sign-in-page.component';
import { SignInEmailStepComponent } from './pages/sign-in-page/email-step/sign-in-email-step.component';
import { SignInPasswordStepComponent } from './pages/sign-in-page/password-step/sign-in-password-step.component';
import { SignInOtpChannelStepComponent } from './pages/sign-in-page/otp-channel-step/sign-in-otp-channel-step.component';
import { SignInOtpEntryStepComponent } from './pages/sign-in-page/otp-entry-step/sign-in-otp-entry-step.component';
import { RegistrationPageComponent } from './pages/registration-page/registration-page.component';
import { InvalidEmailPageComponent } from './pages/invalid-email-page/invalid-email-page.component';
import { SignInRedirectorComponent } from './pages/sign-in-redirector/sign-in-redirector.component';
import { SignInCallbackComponent } from './pages/sign-in-callback/sign-in-callback.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { environment } from '../environments/environment';
import { SignOutPageComponent } from './pages/sign-out-page/sign-out-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { PageGreetingComponent } from './pages/page-greeting/page-greeting.component';
import { PageLoaderComponent } from './pages/page-loader/page-loader.component';

import { AppRoutingModule } from './app-routing.module'; 
//import { NgcCookieConsentConfig, NgcCookieConsentModule} from 'ngx-cookieconsent';

// const cookieConfig:NgcCookieConsentConfig = {
//   cookie: {
//     domain: window.location.hostname
//   },
//   position: "bottom-right",
//   theme: "edgeless",
//   palette: {

//   },
//   layout: 'my-custom-layout',
//   layouts: {
//     "my-custom-layout": `
//     <span class="cookieContainerCls">
//         {{messageContent}}
//         <div class="compButtonContainerCls">
//             <div class="compButtonCls">
//                 {{compliance}}
//             </div>
//         </div>
//     <span>`
//   },
//   elements:{
//     "messageContent": `
//     <div class="cookieMessageCls" >
//       <div class="headerCls"><img src='assets/bell-ringing.svg'/> Cookies notice</div>
//       <div class="messageCls">{{message}}
//       <a class="readMoreCls" href="{{href}}" target="_blank">{{link}}</a>
//       </div>
    
//     </div>
//     `,
//   },
//   "content": {
//      "message": "Our website uses cookies to ensure you<br> get the best experience. If you<br> continue to use the site, we assume you <br>consent to the use of cookies on this<br> site.",
//      dismiss: "Dismiss",
//      "link": "Read more",
//      "href": "https://www.citadel.co.za/privacy-notice/",
//   }
// };

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        SignInPageComponent,
        SignInEmailStepComponent,
        SignInPasswordStepComponent,
        SignInOtpChannelStepComponent,
        SignInOtpEntryStepComponent,
        RegistrationPageComponent,
        InvalidEmailPageComponent,
        SignInRedirectorComponent,
        SignInCallbackComponent,
        ErrorPageComponent,
        SignOutPageComponent,
        ForgotPasswordPageComponent,
        PageGreetingComponent,
        PageLoaderComponent,
    ],
    bootstrap: [AppComponent], 
    imports: [ BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule, CitadelStylesModule, CitadelCoreModule.forRoot({ isProduction: environment.production }), CitadelControlsModule, CitadelOtpInputComponent, CitadelPhoneNumberInputComponent ], providers: [
        { provide: ErrorHandler, useClass: CitadelGlobalErrorHandler },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule { }

